import { render, staticRenderFns } from "./GestionDeclaracionAplicabilidad.vue?vue&type=template&id=60f868e6&"
import script from "./GestionDeclaracionAplicabilidad.vue?vue&type=script&lang=js&"
export * from "./GestionDeclaracionAplicabilidad.vue?vue&type=script&lang=js&"
import style0 from "./GestionDeclaracionAplicabilidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports